module.exports = __webpack_public_path__ + "static/media/file-edit-outline.79bfeb18.svg";